import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {Program, ProgramSite, Site} from '../../../../domain/cloud-topology';
import { firstValueFrom, Subject } from 'rxjs';
import {ProgramService} from '../../../../services/vpp/program.service';
import {takeUntil} from 'rxjs/operators';
import {ToastService} from '../../../../services/toast-service';
import {DataService} from '../../../../services/data.service';
import {ProgramSiteModalComponent} from '../program-site-modal/program-site-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TopologyService } from '../../../../services/topology/topology.service';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-program-sites',
    templateUrl: './program-sites.component.html',
    standalone: false,
  styleUrls: ['./program-sites.component.scss'],
})
export class ProgramSitesComponent implements OnInit, OnChanges, OnDestroy {
  @Input() program: Program;
  @Output() programSitesEmitter = new EventEmitter<ProgramSite[]>();
  dialog = inject(MatDialog)
  programSites: ProgramSite[];
  sites: Site[];
  private subject$: Subject<void>;
  loader = false;

  constructor(private programService: ProgramService,
              private dataService: DataService,
              private topologyService: TopologyService,
              private toastService: ToastService) {}

  ngOnInit(): void {
    this.dataService.getSites().pipe(takeUntil(this.subject$)).subscribe(sites => {
      this.sites = sites;
    });

    this.setData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['program']['currentValue'] !== undefined) {
      this.program = changes['program']['currentValue'];
      this.setData();
    }
  }

  ngOnDestroy(): void {
    this.subject$.next();
  }

  private setData() {
    if (this.program) {
      this.subject$ = new Subject<void>();
      this.programService.getProgramSites(this.program).pipe(takeUntil(this.subject$)).subscribe(programSites => {
        this.programSites = programSites;
      });
    }
  }

  async openSiteModal(button: MatButton): Promise<void> {
    this.loader = true;
    (button._elementRef.nativeElement as HTMLButtonElement).blur();
    const sites = await firstValueFrom(this.topologyService.getTopology());
    const modalRef = this.dialog.open(ProgramSiteModalComponent, {
      width: '600px',
      data: {
        program: this.program,
        programSites: this.getProgramSiteIds(),
        sites
      }
    });
    this.loader = false;
    modalRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        const sitesToSend = [];
        const oldSiteIds = [];
        for (const programSite of this.programSites) {
          oldSiteIds.push(programSite.id);
          if (!result.includes(programSite.id)) {
            sitesToSend.push(programSite.id);
          }
        }

        for (const updatedSite of result) {
          if (!oldSiteIds.includes(updatedSite)) {
            sitesToSend.push(updatedSite);
          }
        }

        this.programService.putProgramSites(this.program, sitesToSend).pipe(takeUntil(this.subject$)).subscribe( data => {

          this.programService.getProgramSites(this.program).pipe(takeUntil(this.subject$)).subscribe(data => {
            this.programSites = data;
            this.programSitesEmitter.emit(this.programSites);
          });

          this.toastService.show(this.program.name + '\'s sites have successfully been updated.', {
            classname: 'bg-success text-light',
            delay: 5000
          });
        }, () => {
          this.toastService.show('Problems updating sites for ' + this.program.name, {
            classname: 'bg-danger text-light',
            delay: 5000
          });
        });
      }
    });
  }

  getProgramSiteIds(): any[] {
    const ids = [];
    for (const programSite of this.programSites) {
      ids.push(programSite.id);
    }

    return ids;
  }
}
